
import { defineComponent } from "vue";
import  ClinicList  from "./ClinicList.vue"

export default defineComponent({
    name: "ClinicRoute",
    components: { 
        ClinicList
    }
});
